<ngx-bootstrap-multiselect
    [settings]="settings"
    [texts]="texts"
    [options]="options"
    [(ngModel)]="idsTiposClassificacoes"
    (ngModelChange)="onChange()"
    [disabled]="disabled">
</ngx-bootstrap-multiselect>